import Vue from 'vue'
import template from './index.pug'

// @vue/component
Vue.component('sidepanel', {
  name: "side-panel",
  template: template(),

  props: {
    open: {
      type: Boolean,
      default: false
    },

    classType: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      internalOpen: false,
      container: null
    }
  },

  computed: {
    openClass() {
      return this.internalOpen ? 'is-open' : ''
    }
  },

  watch: {
    open(newOpen) {
      this.assignOpen(newOpen)
    }
  },

  created() {
    this.assignOpen(this.open)
  },

  mounted() {
    this.calculateHeight()
    // Selecciona el contenedor de scroll real
    this.container = document.querySelector('.sidepanel-map__content .vb-content');
    if (this.container) {
      this.updateScrollBar(); // Inicializa la posición de la barra
      this.container.addEventListener('scroll', this.updateScrollBar.bind(this)); // Asigna el evento con el contexto correcto
    } else {
  
    }
  },

  methods: {
    toggleOpen() {
      this.internalOpen = !this.internalOpen
      if (this.internalOpen) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
      this.$emit('change-open', this.internalOpen)
    },

    assignOpen(newOpen) {
      if (this.internalOpen !== newOpen) {
        this.internalOpen = newOpen
      }
    },

    // Cálculo de altura para permitir scroll en dispositivos iOS antiguos
    calculateHeight() {
      const item = document.getElementsByClassName('sidepanel-map__content')[0]
      item.style.height = `${item.scrollHeight}px`
    },

    updateScrollBar() {
      const scrollHeight = this.container.scrollHeight; // Altura total del contenido
      const clientHeight = this.container.clientHeight; // Altura visible del contenedor
      const scrollTop = this.container.scrollTop; // Desplazamiento actual
      const minScrollBarHeight = 50; // Altura mínima del scrollbar
      const scrollbarHeight = Math.max(minScrollBarHeight, clientHeight * (clientHeight / scrollHeight)); // Calcula la altura de la barra
      
      if (scrollHeight > clientHeight) {
        // Calcula la posición proporcional del scrollbar
        let scrollbarTop = (scrollTop / (scrollHeight - clientHeight)) * (clientHeight - scrollbarHeight);
    
        // Asegura que la posición no exceda los límites
        scrollbarTop = Math.max(0, Math.min(scrollbarTop, clientHeight - scrollbarHeight));
    
        // Aplica las propiedades al contenedor
        this.container.parentElement.style.setProperty('--scrollbar-top', `${scrollbarTop}px`);
        this.container.parentElement.style.setProperty('--scrollbar-height', `${scrollbarHeight}px`);
      }
    }
     
  
  }
})
